import { useCallback, useEffect, useState } from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useMediaQuery } from "@mui/material";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button, DialogTitle, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { axiosInstance } from "../../../utility/apiInstance";
import ModalPopup from "../../../common/ModalPopup";
import SubscriptionForm from "./OceanSubscriptionForm";
import DialogBox from "../../../page/Awbtrackedlist/DialogBox";
import { useRole } from "../../../components/MangeContextProvide";
import OceanMileStone from "./OceanMileStone";
import toast from "react-hot-toast";
import SearchInput from "../../../common/SearchInput";
import { CustomLoadingOverlay, CustomNoRowsOverlay } from "../../../common/Datagridoverlays";

export default function OceanSubscriptionTable() {
  const isMobile = useMediaQuery("(max-width:600px)");
  const isBigScreen = useMediaQuery("(min-width:1800px)");
  const is1366 = useMediaQuery("(max-width:1366px)");
  const { globleCustomerId } = useRole() as any;
  const [rows, setRows] = useState<{ _id: string;[key: string]: any }[]>([]);
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [modalPopup, setmodalPopup] = useState({
    subcriptionPopup: false,
    mileStonePopup: false,
  });
  const [subscriptionFormData, setSubscriptionFormData] = useState({
    awbs: [],
    whatsApp: [],
    emails: [],
    whatsAppMilestones: [],
    emailMilestones: [],
    milestoneList: [],
    mileStoneType: "",
    manageContactList: [],
    subscriptionList: [],
    templateList: [],
    templateName: {},
    whatsappGroupList: [],
    whatsAppgroups: [],
    whatsappGroupMilestones: [],
  }) as any;
  const [editable, setEditable] = useState(false);
  const [editData, setEditData] = useState({}) as any;
  const [errorList, setErrorList] = useState(null);
  const [show, setShow] = useState(false);
  const [statusMessage, setStatusMessage] = useState({}) as any;
  const { milestoneList, manageContactList, subscriptionList } =
    subscriptionFormData;




  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");



  // debounce search effect
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);


  // Fix the debounced effect — pass the string directly
  useEffect(() => {
    getAllSubscription(debouncedSearch);
  }, [debouncedSearch]);


  const columns: GridColDef[] = [
    {
      field: "addedBy",
      headerName: "Addded By",
      // width: 160,
      width: is1366 ? 120 : 160,
      sortable: true,
      filterable: true,
    },

    {
      field: "createdAt",
      headerName: "Created At",
      // width: 160,
      width: is1366 ? 130 : 160,
      sortable: true,
      filterable: true,
      renderCell: (params) => {
        const value = params.row?.createdAt;
        if (!value) return "-";

        const d = new Date(value);
        if (isNaN(d.getTime())) return value;

        const date = `${String(d.getDate()).padStart(2, "0")}-${String(
          d.getMonth() + 1
        ).padStart(2, "0")}-${d.getFullYear()}`;

        const time = `${String(d.getHours()).padStart(2, "0")}:${String(
          d.getMinutes()).padStart(2, "0")
          }`;

        return `${date} ${time}`;
      },
    },

    {
      field: "oceanTrackingNumber",
      headerName: "Tracking Number",
      // width: 160,
      width: is1366 ? 120 : 160,
      sortable: true,
      filterable: true,
    },
    {
      field: "organizationName",
      headerName: "Organization Name",
      //width: isMobile ? 120 : 180,
      width: is1366 ? 150 : 180,
      sortable: true,
      filterable: true,
    },
    {
      field: "salutation",
      headerName: "Channel",
      // width: isMobile ? 120 : 120,
      width: is1366 ? 100 : 150,
      sortable: true,
      filterable: false,
      disableColumnMenu: true,
    },
    {
      field: "name",
      headerName: "Contacts",
      // width: 270,
      width: is1366 ? 110 : 270,
      sortable: true,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div
          style={{
            width: "100%",
            height: "100%",
            maxHeight: 60,
            overflowY: "auto",
            overflowX: "hidden",
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: "18px",
            padding: "2px 0",
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      field: "miletones",
      headerName: "Mletones",
      // width: 450,
      width: is1366 ? 250 : 450,
      sortable: true,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div
          style={{
            width: "100%",
            height: "100%",
            maxHeight: 60,
            overflowY: "auto",
            overflowX: "hidden",
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: "18px",
            padding: "2px 0",
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      // width: 150,
      // flex: 1,
      ...(isBigScreen
        ? { flex: 1, width: 150 }
        : { flex: 0 }),
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params: any) => {
        const { alertType, contacts, awbNumber, _id, customerId } = params.row;
        const contactId = contacts?.[0]?._id;
        return (
          customerId?._id === globleCustomerId && (
            <>
              <div className="flex gap-2">
                <IconButton className="iconMilestone_edit" onClick={() => editSubscription(params)}>
                  <EditIcon />
                </IconButton>
                <IconButton
                  className="iconMilestone_close"
                  color="error"
                  onClick={() =>
                    deleteSubscription(_id, awbNumber, contactId, alertType)
                  }
                >
                  <DeleteIcon />
                </IconButton>
              </div>
            </>
          )
        );
      },
    },
  ];

  useEffect(() => {
    getAllSubscription(debouncedSearch);
    getAllAirBill();
  }, [loading]);

  const getAllAirBill = async () => {
    try {
      let response = await axiosInstance.get(
        "/api/v1/ocean/added-tracking-numbers"
      );
      setSubscriptionFormData((prev: any) => {
        return {
          ...prev,
          subscriptionList: response?.data?.data,
        };
      });
    } catch (err) { }
  };
  const updateSubscriptionFormData = useCallback(
    async (data: any) => {
      setSubscriptionFormData((prev: any) => {
        const { contacts, whatsappGroup } = data?.row;
        return {
          ...prev,
          whatsApp: contacts
            ?.filter(
              (item: any) =>
                data?.row?.alertType === "whatsapp" &&
                contacts
                  ?.map((contact: any) => contact?._id)
                  .includes(item?._id)
            )
            .map((item: any) => ({
              label: item?.name,
              value: item._id,
            })),
          emails: contacts
            ?.filter(
              (item: any) =>
                data?.row?.alertType === "email" &&
                contacts
                  ?.map((contact: any) => contact?._id)
                  .includes(item?._id)
            )
            .map((item: any) => ({
              label: item?.name,
              value: item._id,
            })),
          awbs: prev.subscriptionList
            ?.filter((option: any) =>
              option?.oceanTrackingNumber?.includes(
                data?.row?.oceanTrackingNumber
              )
            )
            ?.map((item: any) => ({
              label: item.oceanTrackingNumber,
              value: item.oceanTrackingNumber,
            })),
          whatsAppMilestones:
            (data?.row?.alertType === "whatsapp" &&
              data?.row?.milestones?.map((milestone: any) => milestone._id)) ||
            [],
          emailMilestones:
            (data?.row?.alertType === "email" &&
              data?.row?.milestones?.map((milestone: any) => milestone._id)) ||
            [],
          whatsAppgroups:
            (data?.row?.alertType === "whatsappgroup" &&
              whatsappGroup?.map((item: any) => ({
                label: item.name,
                value: item._id,
              }))) ||
            [],
          whatsappGroupMilestones:
            (data?.row?.alertType === "whatsappgroup" &&
              data?.row?.milestones?.map((milestone: any) => milestone._id)) ||
            [],
        };
      });
      setEditData(data);
      setEditable(true);
      setmodalPopup((prev) => ({ ...prev, subcriptionPopup: true }));
    },
    [editData, editable]
  );

  const paginationModel = { page: 0, pageSize: 5 };

  const getAllSubscription = async (search: string = "") => {
    setTableLoading(true);
    try {
      let response = await axiosInstance.get(`/api/v1/ocean/subscription?search=${search}`);
      setRows(response?.data?.data);
    } catch (err) {
      toast.error("Failed to fetch subscriptions");
    } finally {
      setTableLoading(false);
    }
  };

  const addSubscription = async () => {
    setLoading(true);
    const { whatsAppMilestones, emailMilestones, whatsappGroupMilestones } =
      subscriptionFormData;

    const whatsApps = subscriptionFormData.whatsApp?.map(
      (item: any) => item.value
    );
    const whatsappGroups = subscriptionFormData.whatsAppgroups?.map(
      (item: any) => item.value
    );
    const emails = subscriptionFormData.emails?.map((item: any) => item.value);
    const oceanTrackingNumber = [subscriptionFormData.awbs]?.map(
      (item: any) => item.value
    );
    const alertType = editData?.row?.alertType;
    let finalUpdateData: any = {};
    if (alertType === "email") {
      finalUpdateData = {
        contacts: emails,
        milestones: emailMilestones,
        alertType: "email",
      };
    } else if (alertType === "whatsapp") {
      finalUpdateData = {
        contacts: whatsApps,
        milestones: whatsAppMilestones,
        alertType: "whatsapp",
      };
    } else if (alertType === "whatsappgroup") {
      finalUpdateData = {
        contacts: whatsappGroups,
        milestones: whatsappGroupMilestones,
        alertType: "whatsappgroup",
      };
    }
    try {
      let response = editable
        ? await axiosInstance.patch(
          `/api/v1/ocean/subscription/update/${editData?.row?._id}`,
          finalUpdateData
        )
        : await axiosInstance.post("/api/v1/ocean/subscription/create", {
          oceanTrackingNumber,
          whatsApps,
          emails,
          whatsAppMilestones,
          emailMilestones,
          whatsappGroups,
          whatsappGroupMilestones,
        });
      if (!editable) {
        if (response.data.message.messageStatus === 1) {
          setStatusMessage(response?.data?.message);
          setShow(true);
          setSubscriptionFormData((prev: any) => ({
            ...prev,
            mileStoneType: "",
            awbs: [],
            whatsApp: [],
            emails: [],
            whatsAppMilestones: [],
            emailMilestones: [],
            templateName: {},
            whatsappGroups: [],
            whatsappGroupMilestones: [],
          }));
        } else {
          setStatusMessage(response?.data?.message);
        }

        if (response.data.data.failed?.length > 0) {
          setErrorList(
            response.data.data.failed?.map((item: any) => ({
              awb: item?.awbNumber,
              reason: item?.reason,
            }))
          );
          setShow(true);
          setLoading(false);
          return;
        }
      } else {
        toast.success(response.data.message)
        setSubscriptionFormData((prev: any) => ({
          ...prev,
          mileStoneType: "",
          awbs: [],
          whatsApp: [],
          emails: [],
          whatsAppMilestones: [],
          emailMilestones: [],
          templateName: {},
          whatsAppgroups: [],
          whatsappGroupMilestones: [],
        }));
      }
      setLoading(false);
      setEditData({});
      setEditable(false);
      setmodalPopup({
        subcriptionPopup: false,
        mileStonePopup: false,
      });
    } catch (error: any) {
      setLoading(false);
      setStatusMessage({});
      if (error.response?.data.error?.length > 0) {
        setErrorList((): any => {
          const errorlog = Array.isArray(error.response.data.error)
            ? error.response.data.error.map((err: any) => {
              return {
                awb: "",
                reason: err.message,
              };
            })
            : [{ awb: "", reason: error.response.data.error }];
          return errorlog;
        });
        setShow(true);
        return;
      }
    }
  };

  const deleteSubscription = async (
    id: string,
    awbNumber: string,
    contactId: string,
    channel: string,
  ) => {
    try {
      let response = await axiosInstance.delete(
        `/api/v1/ocean/subscription/delete/${id}`,
      );
      toast.success(response.data.message)
      setRows((prevRows) => prevRows.filter((row: any) => row._id !== id));
    } catch (err: any) {
      toast.error(err?.response?.data?.error || "Failed to delete")
    }
  };
  const editSubscription = async (data: any) => {
    updateSubscriptionFormData(data);
    getAllMileStone(data?.row?.oceanTrackingNumber)
  };

  const getAllMileStone = async (awb: string) => {
    try {
      let response = await axiosInstance.get(
        `/api/v1/ocean/ocean-achieved-milestone/${awb}`
      );

      setSubscriptionFormData((prev: any) => {
        return {
          ...prev,
          milestoneList: response?.data?.data,
        };
      });
    } catch (err) { }
  };

  const handleAwbChange = useCallback(
    (awb: string) => {
      return getAllMileStone(awb);
    },
    [subscriptionFormData.awbs]
  );

  return (
    <>


      <div className="whiteBox ">
        <div className="buttonadd flex justify-between items-end">
          <SearchInput
            placeholder="Search"
            onChange={setSearchQuery}
            width={400}
          />
          <div className="flex justify-end items-end">
            <Button
              className="btn btnTheme"
              variant="contained"
              onClick={() => {
                setmodalPopup((prev) => ({ ...prev, subcriptionPopup: true }));
                setEditable(false);
                setEditData({});
              }}
            >
              Add Subscription
            </Button>
          </div>
        </div>
        <Paper sx={{ overflow: "hidden", p: 2 }}>
          <DataGrid
            rows={rows?.map((item: any, index: number) => {
              return {
                ...item,
                id: index + 1,
                awbNumber: item.awbNumber,
                salutation: item?.alertType || "-",
                name: item?.contacts?.length
                  ? item.contacts.map((contact: any) => contact?.name).join(",")
                  : item?.whatsappGroup
                    ?.map((group: any) => group?.name)
                    .join(",") || "-",
                miletones:
                  item?.milestones
                    ?.map((mileStone: any) => mileStone?.label)
                    .join(",") || "-",
              };
            })}
            columns={columns}
            loading={tableLoading}
            slots={{
              loadingOverlay: CustomLoadingOverlay,
              noRowsOverlay: CustomNoRowsOverlay,
            }}
            slotProps={{
              loadingOverlay: { message: "Loading subscriptions..." },
              noRowsOverlay: { message: "No subscriptions found" },
            }}
          
            rowHeight={60}
            initialState={{ pagination: { paginationModel } }}
            pageSizeOptions={[5, 10]}
            disableColumnMenu={false}
            sx={{
              // Keeps the loading spinner / "No rows" message from collapsing
              // into a tiny sliver when autoHeight has no row data to size against.
              "--DataGrid-overlayHeight": "300px",
              minHeight: "400px"
            }}
           
            columnHeaderHeight={42}

          />
        </Paper>
      </div>

      <ModalPopup
        open={modalPopup.subcriptionPopup || modalPopup.mileStonePopup}
        handleClose={() => {
          setmodalPopup((prev) => ({
            ...prev,
            subcriptionPopup: false,
            mileStonePopup: false,
          }));
          setSubscriptionFormData((prev: any) => ({
            ...prev,
            mileStoneType: "",
            awbs: [],
            whatsApp: [],
            emails: [],
            whatsAppMilestones: [],
            emailMilestones: [],
            templateName: {},
            milestoneList: [],
          }));
        }}
        heading={""}
      >
        {modalPopup.subcriptionPopup ? (
          <SubscriptionForm
            type="Awb"
            subscriptionFormData={subscriptionFormData}
            manageContactList={manageContactList}
            setmodalPopup={setmodalPopup}
            setSubscriptionFormData={setSubscriptionFormData}
            subscriptionList={subscriptionList}
            loading={loading}
            addSubscription={addSubscription}
            editable={editable}
            editData={editData}
            getAllMileStone={handleAwbChange}
            whatsappGroupList={subscriptionFormData.whatsappGroupList}
          />
        ) : (
          <OceanMileStone
            subscriptionFormData={subscriptionFormData}
            milestoneList={milestoneList}
            setSubscriptionFormData={setSubscriptionFormData}
            onclose={() =>
              setmodalPopup((prev) => ({
                ...prev,
                subcriptionPopup: true,
                mileStonePopup: false,
              }))
            }
          />
        )}
      </ModalPopup>
      <DialogBox
        open={show}
        successMessage={
          <DialogTitle>
            <Typography
              variant="h6"
              className={`font-semibold ${statusMessage?.messageStatus === 1
                ? "text-green-500"
                : "text-red-500"
                }`}
            >
              {statusMessage?.message}
            </Typography>
          </DialogTitle>
        }
        handleClose={() => {
          setShow(false);
          setErrorList(null);
        }}
        data={errorList}
      />
    </>
  );
}